// extracted by mini-css-extract-plugin
module.exports = {"circleBackground":"CircleProgress_circleBackground__tW9c-","circleProgress":"CircleProgress_circleProgress__3staM","percentageText":"CircleProgress_percentageText__gDckb"};